import moment from 'moment'
import Vue from 'vue';
import nationalities from "i18n-nationality";
nationalities.registerLocale(require("i18n-nationality/langs/en.json"));

export default {
    install: (Vue, options) => {
        const global = {
            /**
             * Get image from the url then parsed it into a base64 image
             * @param {string} url the url of the image
             * @return A base64 image
             * */
            getBase64ImageFromURL(url) {
                return new Promise((resolve, reject) => {
                    var img = new Image();
                    img.setAttribute("crossOrigin", "anonymous");
                    img.onload = () => {
                        var canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        var ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        var dataURL = canvas.toDataURL("image/png");
                        resolve(dataURL);
                    };
                    img.onerror = error => {
                        reject(error);
                    };
                    img.src = url;
                });
            },

            /**
             * Format a date
             * @param {date|string} date the date string of date format
             * @param {string} original_format the original format of the date that received from an endpoint (e.g., MM/DD/YYYY)
             * @param {string} format_to the format of the date you want to turn into (e.g., DD/MMM/YYYY)
             * @return A desired date formatted
             * */
            toDate(date, original_format, format_to = 'DD/MMM/YYYY') {
                if (date) {
                    if (original_format) {
                        return moment(String(date), original_format).format(format_to)
                    }
                    return moment(String(date)).format(format_to)
                } else {
                    return '';
                }
            },

            /**
             * Format a number or a string of number into a percentage
             * @param {number|string} value the number or a string of number you want to format
             * @return A string of number percentage
             * */
            toPercent(value) {
                try {
                    return parseFloat(value) + "%";
                }catch (e) {
                    return 'NaN';
                }
            },

            /**
             * Format a given string into a Capitalized string
             * @param {string} text the string you want to format
             * @return A Capitalized string
             * */
            toCapitalize(text) {
                let splitText = text.toLowerCase().split(' ');
                for (let i = 0; i < splitText.length; i++) {
                    splitText[i] = splitText[i].charAt(0).toUpperCase() + splitText[i].substring(1);
                }
                return splitText.join(' ');
            },


            /**
             * Convert number or a string of number, and format to USD format
             * @param {string | number} value - the number or a string of number to format
             * @return A string of USD format
             */
            toCurrency(value) {
                if (typeof value === 'undefined') return value;

                try {
                    value = parseFloat(value);
                }catch (e) {
                    return 'NaN'
                }

                let pre = 'USD ';
                let sub = '';
                if (value === 0) {
                    pre = 'USD ';
                    return pre + '0.00' + sub;
                } else if (value < 0) {
                    value = -value;
                    pre = 'USD (';
                    sub = ')'
                }
                return pre + parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + sub;
            },

            /**
             * Save the data into storage by the given storage type
             * @param {string} key - key of the item
             * @param {*} value - value of item
             * @param {number} hours - the expiration time - default = 24hour
             * @param {number} storageType - The type of storage to use - default = 1. (e.g., Cookies = 1, localStorage = 2, sessionStorage = 3)
             **/
            setItemStorageWithExpiry(key, value, hours = 24, storageType = 1) {
                const now = new Date();
                const item = {
                    value: value,
                    expired: now.getTime() + ((hours * 3600) * 1000),
                }

                setTimeout(() => {
                    storageType = Number(storageType);
                    if (storageType === 1) {
                        Cookies.set(key, JSON.stringify(item));
                    } else if (storageType === 2) {
                        localStorage.setItem(key, JSON.stringify(item));
                    } else {
                        sessionStorage.setItem(key, JSON.stringify(item))
                    }
                }, 300);
            },

            /**
             * Get the data from storage by the given storage type and its key then check if it expired,
             * if it expired remove the key and return null,
             * if not return the value
             * @param {string} key - key of the item
             * @param {number} storageType - The type of storage to use - default = 1. (e.g., Cookies = 1, localStorage = 2, sessionStorage = 3)
             * */
            getItemStorageWithExpiry(key, storageType = 1) {
                let itemStr = null;
                storageType = Number(storageType);
                if (storageType === 1) {
                    itemStr = Cookies.get(key);
                } else if (storageType === 2) {
                    itemStr = localStorage.getItem(key);
                } else {
                    itemStr = sessionStorage.getItem(key);
                }
                // if the item doesn't exist, return null
                if (!itemStr) return null;

                const item = JSON.parse(itemStr);
                const now = new Date();
                // compare the expiry time of the item with the current time
                if (now.getTime() > item.expired) {
                    // If the item is expired, delete the item from storage and return null
                    if (storageType === 1) {
                        Cookies.remove(key);
                    } else if (storageType === 2) {
                        localStorage.removeItem(key);
                    } else {
                        sessionStorage.removeItem(key);
                    }
                    return null;
                }
                return item.value;
            },

            /**
             ** Turn blob data into a file
             ** @param {string} blob - blob data
             ** @param {string|number} fileName - name of the file
             ** @param {string} MIME_TYPE - type of the upload file
             **/
            blobToFile(blob, fileName = new Date().getTime(), MIME_TYPE, ext = '.png') {
                return new File([blob], fileName + ext, {type: MIME_TYPE});
            },
            getNationality(code){
                return nationalities.getName(code,'en')
            },
        }
        Vue.prototype.$global = global;
    }
}
